import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 50px auto;
  max-width: 450px;
  padding: 1rem 0;
  border-radius: 16px;
  background-color: var(--white);
  /* elevation */
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.19), 0 4px 4px rgba(0, 0, 0, 0.23);

  @media screen and (max-width: 576px) {
    margin: 75px auto;
  }

  .form-title {
    text-align: center;
    color: var(--black);
    padding: 2rem 0;
    margin: 0;
    font-size: var(--fontSuperBig);

    @media screen and (max-width: 576px) {
      font-size: 1.5rem;
    }
  }
  .btn-primary {
    border-radius: 24px;
    @media screen and (max-width: 576px) {
      font-size: 1.2rem;
    }
  }

  .link,
  .link-text {
    @media screen and (max-width: 576px) {
      font-size: 0.8rem;
    }
  }

  h3 {
    color: var(--medGray);
  }
`;
